import React from 'react';
import { Providers } from "@tpd-web-common-libs/nodejs-library";
import DynamicPage from "./[...slugs]";
import RoutingService from "../providers/routing.service";
import remotesMap from "../remotes/remotesMap";
import { PHASE_PRODUCTION_BUILD } from "next/constants";

export async function getStaticProps() {
  // INIT REMOTES FOR NEXT
  const remoteService = Providers.RemoteService.getInstance();
  if(process.env.NEXT_PHASE !== PHASE_PRODUCTION_BUILD) {
    remoteService.initRemotesMap(remotesMap);
  }
  const routingService = RoutingService.getInstance();
  return routingService.generateStaticProps("/error-404");
}

export default DynamicPage;
